// extracted by mini-css-extract-plugin
export default {"container":"UQcs","loaderContainer":"BSBG"};